import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { MAP_INCIDENT_TYPE_TO_URL_PREFIX } from 'containers/ResolutionCenter/constants'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../../PartnerOptions/constants'

import {
  addCommentReplyError,
  addCommentReplySuccess,
  dismissInsightError,
  dismissInsightSuccess,
  getBlockedAttacksActivityLogError,
  getBlockedAttacksActivityLogSuccess,
  getCampaignsActivityLogError,
  getCampaignsActivityLogSuccess,
  getCommentsActivityLogError,
  getCommentsActivityLogSuccess,
  getIncidentsActivityLogError,
  getIncidentsActivityLogSuccess,
  getInsightsError,
  getInsightsSuccess,
} from './actions'
import {
  ADD_COMMENT_REPLY_REQUEST_ASYNC,
  BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC,
  CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC,
  COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC,
  DISMISS_INSIGHTS_REQUEST_ASYNC,
  INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC,
  INSIGHTS_REQUEST_ASYNC,
} from './constants'

const incidentsActivityLogEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getIncidentsActivityLog(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getIncidentsActivityLogSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getIncidentsActivityLogError, error)))
        .takeUntil(action$.ofType(INCIDENTS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL))
    )

const campaignsActivityLogEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getCampaignsActivityLog(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getCampaignsActivityLogSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getCampaignsActivityLogError, error)))
        .takeUntil(action$.ofType(CAMPAIGNS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL))
    )

const commentsActivityLogEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
      ADD_COMMENT_REPLY_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getCommentsActivityLog(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getCommentsActivityLogSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getCommentsActivityLogError, error)))
        .takeUntil(action$.ofType(COMMENTS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL))
    )

const blockedAttacksActivityLogEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.INITIATE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getBlockedAttacksActivityLog(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getBlockedAttacksActivityLogSuccess(response))
        .catch((error) =>
          Observable.of(epicsErrorHandler(getBlockedAttacksActivityLogError, error))
        )
        .takeUntil(action$.ofType(BLOCKED_ATTACKS_ACTIVITY_LOG_REQUEST_ASYNC.CANCEL))
    )

const addCommentReplyEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(ADD_COMMENT_REPLY_REQUEST_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap((action) =>
      api.resolutionCenter
        .addReportComment(
          action.payload.reportId,
          {
            comment: action.payload.text,
            parentId: action.payload.commentId,
            isCommunity: false,
          },
          action.payload.reportTypePrefix
        )
        .map((response) => addCommentReplySuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(addCommentReplyError, error)))
        .takeUntil(action$.ofType(ADD_COMMENT_REPLY_REQUEST_ASYNC.CANCEL))
    )

const insightsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      INSIGHTS_REQUEST_ASYNC.INITIATE,
      DISMISS_INSIGHTS_REQUEST_ASYNC.SUCCESS,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getInsights(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getInsightsSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getInsightsError, error)))
        .takeUntil(action$.ofType(INSIGHTS_REQUEST_ASYNC.CANCEL))
    )

const dismissInsightEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(DISMISS_INSIGHTS_REQUEST_ASYNC.INITIATE)
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.dashboard.home)
      return true
    })
    .mergeMap((action) =>
      api.dashboard
        .dismissInsight(store.getState().partnerOptions.selectedCompany?.value, action.payload.data)
        .map((response) => dismissInsightSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(dismissInsightError, error)))
        .takeUntil(action$.ofType(DISMISS_INSIGHTS_REQUEST_ASYNC.CANCEL))
    )

export default combineEpics(
  incidentsActivityLogEpic,
  campaignsActivityLogEpic,
  commentsActivityLogEpic,
  blockedAttacksActivityLogEpic,
  addCommentReplyEpic,
  insightsEpic,
  dismissInsightEpic
)
